export default __webpack_public_path__ + "static/media/a' dèanamh.bb99bc07.mp3";